var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.details)?_c('div',{staticStyle:{"border-top":"1px solid #eee"}},[_c('router-view',{attrs:{"is_grouped":true,"element":_vm.details.element}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }